import { gql } from '@apollo/client'

// Copied from src/query/packaging-processing-activity.ts and adapted for the packaging Material
// Emission Factors grid (story 36910): search narrowed to material name / category / country, node
// selection ordered to match the story's column list. Column headers themselves come from the
// __type introspection block plus the view's field descriptions, not from this selection.
export const GET_ALL_MATERIAL_EMISSION_FACTORS = gql`
  query AllMaterialEmissionFactors(
    $str: String
    $secondaryDataReferenceSourceType: NullableOfReferenceSourceTypeEnumOperationFilterInput
    $state: StateEnumOperationFilterInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [EmissionFactorsGraphQlSortInput!]
  ) {
    secondaryDataReferenceSourceType: __type(name: "ReferenceSourceTypeEnum") {
      name
      enumValues {
        name
        description
      }
    }
    state: __type(name: "StateEnum") {
      name
      enumValues {
        name
        description
      }
    }
    functionalUnit: __type(name: "FunctionalUnitEnum") {
      name
      enumValues {
        name
        description
      }
    }
    emissionFactor: __type(name: "EmissionFactorsGraphQl") {
      fields {
        name
        description
      }
    }

    packagingEmissionFactors(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        id: { gt: 0 }
        type: { eq: Packaging }
        or: [
          { packagingMaterialName: { contains: $str } }
          { packagingMaterialCategory: { contains: $str } }
          { countryName: { contains: $str } }
          { secondaryDataReferenceSourceType: $secondaryDataReferenceSourceType }
          { state: $state }
        ]
      }
      order: $order
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          code
          state
          isRecycled
          includesProcessingImpacts
          packagingMaterialClass
          packagingMaterialCategory
          packagingMaterialName
          countryName
          countryISOCode
          regionIdentifier
          functionalUnit
          dataOrigin
          dataOriginComment
          proxyNote
          landUse
          biodiversity
          carbon
          eutrophication
          waterUsage
          waterUsageIncludingWasterScarcity
          dataQualityReliabilityScore
          lastPublishedDate
          researcherName
          isVerified
          verifiedOn
          lastUpdatedName
          updated
        }
      }
    }
  }
`
